import React from 'react'
import { useSelector } from 'react-redux'

import BaseModal from './BaseModal'
import { Card } from 'ui'

import { t } from 'translations'

function EmployeeScheduleProjectInformationModal({ projectId }) {
  const { projectsById } = useSelector(state => state.resources)
  const { projectOwners, name } = projectsById[projectId]

  return (
    <BaseModal title="employee.mySchedule.PROJECT_INFO_MODAL">
      <Card maxHeight="10rem" className="bg-light py-2">
        <div>
          <b className="mt-2 mx-2">{t('employee.mySchedule.PROJECT_INFO_MODAL.PROJECT_NAME')}</b>
          <p className="mx-2">{name}</p>
        </div>
        <div>
          <b className="mt-3 mx-2">{t('employee.mySchedule.PROJECT_INFO_MODAL.PROJECT_OWNERS')}</b>
          <ul>
            {projectOwners.map(owner => (
              <li key={owner._id}>{owner.fullName}</li>
            ))}
          </ul>
        </div>
      </Card>
    </BaseModal>
  )
}

export default EmployeeScheduleProjectInformationModal
